export default {
  methods: {
    isPermanent(reward) {
      return !reward.item.duration;
    },
    itemDuration(reward) {
      let result = {
          text: "",
          type_icon: "",
        },
        duration = null;

      switch (reward.type) {
        case "bp":
          result.text = "-";
          result.type_icon = "points";
          return result;
        case "personal_box_class":
          result.text = "-";
          result.type_icon = "infinity";
          return result;
      }

      duration = reward.item.duration;

      if (reward.item.consumable) {
        result.text = reward.item.count + " " + this.$i18n.t("common.count_short");
        result.type_icon = "ammo-type";
        return result;
      }

      if (!reward.item.duration) {
        if (reward.item.regular) {
          result.text = this.$i18n.t("common.permanent");
          result.type_icon = "skin-type";

          return result;
        } else {
          result.text = this.$i18n.t("common.permanent");
          result.type_icon = "infinity";

          return result;
        }
      }

      switch (reward.item.duration_type) {
        case "day":
          result.text = duration + " " + this.$i18n.t("common.days_short");
          result.type_icon = "timer";
          break;
        case "hour":
          result.text = duration + " " + this.$i18n.t("common.hours_short");
          result.type_icon = "timer";
          break;
      }
      return result;
    },
  },
};
